import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

type TQuery = {
  pageNumber: number;
  size: number;
  consumerType?: string;
  customerId?: string;
  Tenant?: string | null;
};

export interface WalletAccount {
  id: number;
  userId: number;
  clientId: string;
  targetId: number;
  walletId: string;
  accountName: string;
  accountNumber: string;
  bankName: string;
  walletProvider: string;
  walletProviderId: number;
  consumerType: string;
  currency: string;
  availableBalance: number;
  isDefault: boolean;
}

const getAllCustomerWallet = async ({
  pageNumber,
  size,
  consumerType,
  customerId,
  Tenant,
}: TQuery) => {
  let queryParams = `Page=${pageNumber}&PageSize=${size}`;

  if (consumerType) {
    queryParams = `${queryParams}&ConsumerType=${consumerType}`;
  }
  if (customerId) {
    queryParams = `${queryParams}&TargetId=${customerId}`;
  }

  if (Tenant) {
    queryParams = `${queryParams}&Tenant=${Tenant}`;
  }
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.GET_ALL_WALLET}?${queryParams}`,
  );

  return data;
};

export const useAllCustomerWallet = ({
  pageNumber,
  size,
  consumerType,
  customerId,
  Tenant,
}: TQuery) => {
  return useQuery(
    [
      { pageNumber, size, consumerType, customerId, Tenant },
      "getAllCustomerWallet",
    ],
    getAllCustomerWallet,
  );
};
